export default {
      id: "icon-thumb-up-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-thumb-up",
      toString: function () {
        return this.url;
      }
    }